// Auto-generated skeleton for Note

import { CisType } from "./CisType";
import { User } from "./User";
import { Address } from "./Address";

export const Note: Api.Note = {
  id: 0,
  user_id: 0,
  subject: '',
  content: '',
  location_description: null,
  address_id: 0,
  date_start: null,
  date_end: null,
  valid_until: null,
  cis_type_id: 0,
  cis_type: CisType,
  creator: User,
  notes_types: null,
  address: Address,
  buildings: [],
  documents: [],
  document_files: [],
  cis: '',
  roles: [],
  notification_level: 0,
  priority: false,
  synced_at: null,
  created: null,
  updated: null,
};

